import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "serp__filter--category q-list-group q-px-0"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["value", "onChange", "checked"]


import SubCategoryItem from "@/components/SerpPage/FiltersContainer/FiltersList/FilterItem/SubCategoryItem.vue";
import FilterLabel from "@/components/SerpPage/FiltersContainer/FiltersList/FilterItem/FilterLabel.vue";

import {useFiltersStore} from "@/store/SerpPage/FiltersStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'CategoryItem',
  props: ['filterData', 'field',],
  emits: ['closeDropdown'],
  setup(__props, { emit: __emit }) {



const filtersStore = useFiltersStore();


const emit = __emit;

function updateCategoryItem(field: string, label:string) {
  filtersStore.updateCategoryItem(field, label)
  emit('closeDropdown');
}



return (_ctx: any,_cache: any) => {
  return (__props.filterData.values.length > 0)
    ? (_openBlock(), _createElementBlock("li", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.filterData.values, (filter) => {
          return (_openBlock(), _createElementBlock("div", {
            key: filter.id
          }, [
            (filter.label !=='')
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("input", {
                    class: "serp__filter--category-input q-form-check-input q-me-2",
                    type: "checkbox",
                    value: __props.field,
                    onChange: ($event: any) => (updateCategoryItem(__props.field, filter.label)),
                    checked: _unref(filtersStore).filterIsChecked(__props.field, filter.label)
                  }, null, 40, _hoisted_3),
                  _createVNode(FilterLabel, { filter: filter }, null, 8, ["filter"]),
                  _createVNode(SubCategoryItem, {
                    filter: filter,
                    field: __props.field
                  }, null, 8, ["filter", "field"])
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})